import { Col, DatePicker, Form, Input, Radio, Row, Select } from 'antd';
import React, { Fragment, useEffect, useRef, useState } from 'react';
import {
  Gender,
  Marital_Status,
  Race,
  Residence,
  Titles,
} from '../../common/Constants';
import { Field, Formik, ErrorMessage } from 'formik';
import { InitialData } from '../../common/InitialData';
import { ServerAPI } from '../../common/ServerAPI';
import dayjs from 'dayjs';
import { RequiredFields } from '../../common/RequiredFields';
import {
  convertObject,
  hasKeysAndNotEmpty,
  reverseObject,
} from '../../common/Utilities';

const GuarantorPersonalDetails = ({
  type,
  guarantor_index,
  updateFunction,
  guarantor_type,
  existingGuarantors
}) => {
  const [applicantDetails, setApplicantDetails] = useState({});
  const [validationDetails, setValidationDetails] = useState({});
  const [emailMessage, setEmailMessage] = useState('Email Required');
  const [currentGuarantors, setCurrentGuarantors] = useState(null);

  const handleBlur = async (e, formikProps) => {
    let updateData = {}
    const { name, value } = e.target;
    updateData =
      Object.keys(validationDetails).length == 0
        ? convertObject(formikProps.values)
        : { ...validationDetails };
    if (updateData[name]) {
      updateData[name]['validation'] = value != '' ? true : false;
      updateData[name]['value'] = value;
    }
    if (name == 'email') {
      if (value.match(/^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/)) {
        updateData['email']['validation'] = true;
      } else if (value == '') {
        setEmailMessage('email Required');
      } else {
        setEmailMessage('Invalid Email');
        updateData['email']['validation'] = false;
      }
    }
    if (name === 'mobile_no') {
      updateData['office']['validation'] = true;
    }
    if (guarantor_type == 'individual') {
      if (name === 'mobile_no') {
        updateData['home_no']['validation'] = true;
      }
    }
    formikProps.setFieldValue(name, value);
    formikProps.setFieldTouched(name, true);
    setApplicantDetails(formikProps.values);
    setValidationDetails(updateData);
    localStorage.setItem(
      'guarantor_personal_details_' + guarantor_index,
      JSON.stringify(updateData)
    );
    if (name == 'nric') {
      let savedValues = JSON.parse(
        localStorage.getItem('guarantor_details_' + guarantor_index)
      );
      if (savedValues) {
        savedValues['guarantor_nric'] = value;
        const response = await ServerAPI.updateApplication(
          'guarantor',
          savedValues
        );
      }
    }
    if (name == 'uen_acra_no') {
      let savedValues = JSON.parse(
        localStorage.getItem('guarantor_details_' + guarantor_index)
      );
      if (savedValues) {
        savedValues['guarantor_nric'] = value;
        savedValues['guarantor_citizenship_type'] = 'company';
        const response = await ServerAPI.updateApplication(
          'guarantor',
          savedValues
        );
        // delete savedValues['guarantor_nric'];
        localStorage.setItem(
          'guarantor_details_' + guarantor_index,
          JSON.stringify(savedValues)
        );
      }
    }


  };

  const handleChange = (e, formikProps) => {
    let data = { ...formikProps.values };
    const { name, value } = e.target;
    let updateData =
      Object.keys(validationDetails).length == 0
        ? convertObject(data)
        : validationDetails;
    updateData[name]['validation'] = value != '' ? true : false;
    updateData[name]['value'] = value;
    if (name == 'home_address_same_as_mailing' && value == 0) {
      data['home_address_same_as_mailing'] = 0;
      formikProps.setFieldValue(name, 0);
      formikProps.setFieldTouched(name, true);
      updateData['home_address_same_as_mailing']['value'] = 0;
      updateData['home_address_same_as_mailing']['validation'] = true;
      updateData['mailing_home_address']['validation'] = false;
      updateData['mailing_postal_code']['validation'] = false;
      updateData['mailing_residence_type']['validation'] = false;
    } else if (name == 'home_address_same_as_mailing' && value == 1) {
      formikProps.setFieldValue(name, 1);
      formikProps.setFieldTouched(name, true);
      data['home_address_same_as_mailing'] = 1;
      updateData['home_address_same_as_mailing']['value'] = 1;
      updateData['home_address_same_as_mailing']['validation'] = true;
      updateData['mailing_home_address']['validation'] = true;
      updateData['mailing_postal_code']['validation'] = true;
      updateData['mailing_residence_type']['validation'] = true;
    } else if (name == 'company_address_same_as_mailing' && value == 0) {
      formikProps.setFieldValue(name, 0);
      formikProps.setFieldTouched(name, true);
      data['company_address_same_as_mailing'] = 0;
      updateData['company_address_same_as_mailing']['validation'] = true;
      updateData['company_address_same_as_mailing']['value'] = 0;
      updateData['mailing_company_address']['validation'] = false;
      updateData['mailing_company_postal_code']['validation'] = false;
    } else if (name == 'company_address_same_as_mailing' && value == 1) {
      formikProps.setFieldValue(name, 1);
      formikProps.setFieldTouched(name, true);
      updateData['company_address_same_as_mailing']['validation'] = true;
      updateData['company_address_same_as_mailing']['value'] = 1;
      data['company_address_same_as_mailing'] = 1;
      updateData['mailing_company_address']['validation'] = true;
      updateData['mailing_company_postal_code']['validation'] = true;
    }
    setApplicantDetails(data);
    setValidationDetails(updateData);
    localStorage.setItem(
      'guarantor_personal_details_' + guarantor_index,
      JSON.stringify(updateData)
    );
  };

  const handleDropdownChange = (name, value, formikProps) => {
    let data = { ...applicantDetails };
    formikProps.setFieldValue(name, value);
    formikProps.setFieldTouched(name, true);
    data[name] = value;
    let updateData =
      Object.keys(validationDetails).length == 0
        ? convertObject(data)
        : validationDetails;
    updateData[name]['validation'] = value != '' ? true : false;
    updateData[name]['value'] = value;
    if (name == 'marital_status' && value == 'Single') {
      updateData['name_of_spouse']['validation'] = true;
    }
    setApplicantDetails(data);
    setValidationDetails(updateData);
    localStorage.setItem(
      'guarantor_personal_details_' + guarantor_index,
      JSON.stringify(updateData)
    );
  };

  useEffect(() => {
    let savedValues = {};
    savedValues = localStorage.getItem(
      'guarantor_personal_details_' + guarantor_index
    );
    if (savedValues && Object.keys(savedValues).length != 0) {
      let parsedValues = JSON.parse(savedValues);
      setValidationDetails(parsedValues);
      setCurrentGuarantors(
        Array.isArray(existingGuarantors) && guarantor_index > 0
          ? existingGuarantors[guarantor_index - 1]?.personal_details ?? null
          : null
      );
      parsedValues = Object.entries(parsedValues).reduce((acc, [key, { value, disabled }]) => {
        acc[key] = value;
        return acc;
      }, {});
      setApplicantDetails(parsedValues);
    } else {
      if (guarantor_type == 'individual') {
        setApplicantDetails(InitialData.applicant_details);
      } else {
        setApplicantDetails(InitialData.applicant_details_company);
      }
    }
  }, [guarantor_index, existingGuarantors]);

  // console.log("===========================", currentGuarantors)
  return (
    <div>
      {guarantor_type == 'individual' && (
        <Formik enableReinitialize={true} initialValues={applicantDetails}>
          {(formikProps) => (
            <Form layout='vertical'>
              <div className='input-one-line-dealer'>
                <div className='input-group w-full md:w-[230px]'>
                  <label>Title</label>
                  <Form.Item className='mt-1 w-full'>
                    <Field>
                      {({ field }) => (
                        <Select
                          {...field}
                          name='title'
                          onChange={(e) => {
                            handleDropdownChange('title', e, formikProps);
                          }}
                          options={Titles}
                          disabled={currentGuarantors?.missing_fields ? !currentGuarantors.missing_fields.includes('title') : false}
                          //disabled={applicantDetails.title_//disabled}
                          value={applicantDetails.title}
                        />
                      )}
                    </Field>
                    {validationDetails?.title?.validation == false && (
                      <span className='error'>Title Required</span>
                    )}
                  </Form.Item>
                </div>
                <div className='input-group w-full md:w-[230px]'>
                  <label className='form-field-label'>Name</label>
                  <Form.Item name='field2' className='mt-1'>
                    <Field name='name'>
                      {({ field }) => (
                        <Input
                          {...field}
                          onBlur={(e) => handleBlur(e, formikProps)}
                          disabled={currentGuarantors?.missing_fields ? !currentGuarantors.missing_fields.includes('name') : false}


                        />
                      )}
                    </Field>
                    {validationDetails?.name?.validation == false && (
                      <span className='error'>Name Required</span>
                    )}
                  </Form.Item>
                </div>
                <div className='input-group w-full md:w-[230px]'>
                  <Fragment>
                    <label className='form-field-label'>NRIC</label>
                    <Form.Item name='field2' className='mt-1'>
                      <Field name='nric'>
                        {({ field }) => (
                          <Input
                            {...field}
                            onBlur={(e) => handleBlur(e, formikProps)}
                            disabled={currentGuarantors?.missing_fields ? !currentGuarantors.missing_fields.includes('nric') : false}

                          />
                        )}
                      </Field>
                      {validationDetails?.nric?.validation == false && (
                        <span className='error'>NRIC Required</span>
                      )}
                    </Form.Item>
                  </Fragment>
                </div>
                <div className='input-group w-full md:w-[230px]'>
                  <label className='form-field-label'>Date of Birth</label>
                  <Form.Item name='field2' className='mt-1 w-full'>
                    <Field name='dob'>
                      {({ field }) => (
                        <DatePicker
                          className={`py-[8px] w-full md:w-[230px]`}
                          allowClear={false}
                          format='DD-MM-YYYY'
                          {...field}
                          value={
                            applicantDetails.dob
                              ? dayjs(applicantDetails.dob)
                              : null
                          }
                          name='dob'
                          disabled={currentGuarantors?.missing_fields ? !currentGuarantors.missing_fields.includes('dob') : false}

                          onChange={(date) => {
                            handleDropdownChange(
                              'dob',
                              dayjs(date).format('YYYY-MM-DD'),
                              formikProps
                            );
                          }}
                        //disabledDate={(d) => d.isAfter(dayjs())}
                        />
                      )}
                    </Field>
                    {validationDetails?.dob?.validation == false && (
                      <span className='error'>DOB Required</span>
                    )}
                  </Form.Item>
                </div>
              </div>
              <div className='input-one-line-dealer'>
                <div className='input-group w-full md:w-[230px]'>
                  <label>Gender</label>
                  <Form.Item className='mt-1 w-full'>
                    <Field name='gender'>
                      {({ field }) => (
                        <Select
                          {...field}
                          name='gender'
                          disabled={currentGuarantors?.missing_fields ? !currentGuarantors.missing_fields.includes('gender') : false}
                          onChange={(e) => {
                            handleDropdownChange('gender', e, formikProps);
                          }}
                          options={Gender}
                          value={applicantDetails.gender}
                        />
                      )}
                    </Field>
                    {validationDetails?.gender?.validation == false && (
                      <span className='error'>Gender Required</span>
                    )}
                  </Form.Item>
                </div>
                <div className='input-group w-full md:w-[230px]'>
                  <label>Race</label>
                  <Form.Item className='mt-1 w-full'>
                    <Field name='race'>
                      {({ field }) => (
                        <Select
                          {...field}
                          name='race'
                          disabled={currentGuarantors?.missing_fields ? !currentGuarantors.missing_fields.includes('race') : false}

                          onChange={(e) => {
                            handleDropdownChange('race', e, formikProps);
                          }}
                          options={Race}
                          value={applicantDetails.race}
                        />
                      )}
                    </Field>
                    {validationDetails?.race?.validation == false && (
                      <span className='error'>Race Required</span>
                    )}
                  </Form.Item>
                </div>
                <div className='input-group w-full md:w-[230px]'>
                  <label>Marital Status</label>
                  <Form.Item className='mt-1 w-full'>
                    <Field name='marital_status'>
                      {({ field }) => (
                        <Field>
                          {({ field }) => (
                            <Select
                              {...field}
                              name='marital_status'
                              onChange={(e) => {
                                handleDropdownChange(
                                  'marital_status',
                                  e,
                                  formikProps
                                );
                              }}
                              disabled={false}
                              options={Marital_Status}
                              value={applicantDetails.marital_status}
                            />
                          )}
                        </Field>
                      )}
                    </Field>
                    {validationDetails?.marital_status?.validation == false && (
                      <span className='error'>Marital Status Required</span>
                    )}
                  </Form.Item>
                </div>
                {formikProps.values.marital_status == 'Married' && (
                  <div className='input-group w-full md:w-[230px]'>
                    <label className='ml-2'>Name of Spouse</label>
                    <Form.Item name='field2' className='mt-1 ml-2'>
                      <Field name='name_of_spouse'>
                        {({ field }) => (
                          <Input
                            {...field}
                            onBlur={(e) => handleBlur(e, formikProps)}
                            disabled={currentGuarantors?.missing_fields ? currentGuarantors.missing_fields.includes('name_of_spouse') : false}
                          />
                        )}
                      </Field>
                      {validationDetails?.name_of_spouse?.validation ==
                        false && (
                          <span className='error'>Name of Spouse Required</span>
                        )}
                    </Form.Item>
                  </div>
                )}
              </div>
              <div className='input-one-line-dealer'>
                <div className='input-group w-full md:w-[230px]'>
                  <label>Home Number</label>
                  <Form.Item name='field2' className='mt-1'>
                    <Field name='home_no'>
                      {({ field }) => (
                        <Input
                          maxLength={8}
                          addonBefore={'+65'}
                          disabled={currentGuarantors?.missing_fields ? !currentGuarantors.missing_fields.includes('home_no') : false}

                          {...field}
                          onBlur={(e) => handleBlur(e, formikProps)}
                        />
                      )}
                    </Field>
                  </Form.Item>
                </div>
                <div className='input-group w-full md:w-[230px]'>
                  <label>Mobile Number</label>
                  <Form.Item name='field2' className='mt-1'>
                    <Field name='mobile_no'>
                      {({ field }) => (
                        <Input
                          maxLength={8}
                          addonBefore={'+65'}
                          //disabled={applicantDetails.mobile_no}
                          disabled={currentGuarantors?.missing_fields ? !currentGuarantors.missing_fields.includes('mobile_no') : false}

                          {...field}
                          onBlur={(e) => handleBlur(e, formikProps)}
                        />
                      )}
                    </Field>
                    {validationDetails?.mobile_no?.validation == false && (
                      <span className='error'>Mobile Number Required</span>
                    )}
                  </Form.Item>
                </div>
                <div className='input-group w-full md:w-[230px]'>
                  <label>Office Number</label>
                  <Form.Item name='field2' className='mt-1'>
                    <Field name='office'>
                      {({ field }) => (
                        <Input
                          maxLength={8}
                          addonBefore={'+65'}
                          //disabled={applicantDetails.office}
                          disabled={currentGuarantors?.missing_fields ? !currentGuarantors.missing_fields.includes('office') : false}

                          {...field}
                          onBlur={(e) => handleBlur(e, formikProps)}
                        />
                      )}
                    </Field>
                  </Form.Item>
                </div>
                <div className='input-group w-full md:w-[230px]'>
                  <label className='ml-2'>Email</label>
                  <Form.Item name='field2' className='mt-1 ml-2'>
                    <Field name='email'>
                      {({ field }) => (
                        <Input
                          {...field}
                          //disabled={applicantDetails.email}
                          disabled={currentGuarantors?.missing_fields ? !currentGuarantors.missing_fields.includes('email') : false}

                          onBlur={(e) => handleBlur(e, formikProps)}
                        />
                      )}
                    </Field>
                    {validationDetails?.email?.validation == false && (
                      <span className='error'>{emailMessage}</span>
                    )}
                  </Form.Item>
                </div>
              </div>
              <div className='input-one-line-dealer'>
                <div className='input-group w-full md:w-[230px]'>
                  <label>Residence Type</label>
                  <Form.Item className='mt-1 w-full'>
                    <Field name='residence_type'>
                      {({ field }) => (
                        <Select
                          {...field}
                          name='residence_type'
                          onChange={(e) => {
                            handleDropdownChange(
                              'residence_type',
                              e,
                              formikProps
                            );
                          }}
                          options={Residence}
                          //disabled={applicantDetails.residence_type}
                          disabled={currentGuarantors?.missing_fields ? !currentGuarantors.missing_fields.includes('residence_type') : false}

                          value={applicantDetails.residence_type}
                        />
                      )}
                    </Field>
                    {validationDetails?.residence_type?.validation == false && (
                      <span className='error'>Residence Type Required</span>
                    )}
                  </Form.Item>
                </div>
                <div className='input-group w-full md:w-[230px]'>
                  <label>Home Address</label>
                  <Form.Item name='field3' className='mt-1'>
                    <Field name='home_address'>
                      {({ field }) => (
                        <Input
                          {...field}
                          onBlur={(e) => handleBlur(e, formikProps)}
                          disabled={currentGuarantors?.missing_fields ? !currentGuarantors.missing_fields.includes('home_address') : false}

                        />
                      )}
                    </Field>
                    {validationDetails?.home_address?.validation == false && (
                      <span className='error'>Home Address Required</span>
                    )}
                  </Form.Item>
                </div>
                <div className='input-group w-full md:w-[230px]'>
                  <label>Postal Code</label>
                  <Form.Item name='field3' className='mt-1'>
                    <Field name='postal_code'>
                      {({ field }) => (
                        <Input
                          maxLength={6}
                          {...field}
                          disabled={currentGuarantors?.missing_fields ? !currentGuarantors.missing_fields.includes('postal_code') : false}

                          onBlur={(e) => handleBlur(e, formikProps)}
                        />
                      )}
                    </Field>
                    {validationDetails?.postal_code?.validation == false && (
                      <span className='error'>Postal Code Required</span>
                    )}
                  </Form.Item>
                </div>
              </div>
              <div className='input-one-line-dealer'>
                <div>
                  <label>Home address same as mailing address?</label>
                  <Form.Item name='field3' className='mt-1'>
                    <Field name='home_address_same_as_mailing'>
                      {({ field }) => (
                        <Radio.Group
                          {...field}
                          onChange={(e) => handleChange(e, formikProps)}
                        >
                          <Radio key={1} value={1}>
                            <p className='form-field-label'>Yes</p>
                          </Radio>
                          <Radio key={0} value={0}>
                            <p className='form-field-label'>No</p>
                          </Radio>
                        </Radio.Group>
                      )}
                    </Field>
                    <br />
                    {validationDetails?.home_address_same_as_mailing
                      ?.validation == false && (
                        <span className='error'>Required</span>
                      )}
                  </Form.Item>
                </div>
              </div>
              {formikProps.values.home_address_same_as_mailing == 0 &&
                validationDetails?.home_address_same_as_mailing?.validation ==
                true && (
                  <div className='input-one-line-dealer'>
                    <div>
                      <label className='form-field-label'>
                        Mailing Residence Type
                      </label>
                      <Form.Item className='mt-1 w-full'>
                        <Field name='mailing_residence_type'>
                          {({ field }) => (
                            <Select
                              {...field}
                              name='mailing_residence_type'
                              onChange={(e) => {
                                handleDropdownChange(
                                  'mailing_residence_type',
                                  e,
                                  formikProps
                                );
                              }}
                              options={Residence}
                              value={applicantDetails.mailing_residence_type}
                            />
                          )}
                        </Field>
                        {validationDetails?.mailing_residence_type
                          ?.validation == false && (
                            <span className='error'>
                              Mailing Residence Type Required
                            </span>
                          )}
                      </Form.Item>
                    </div>
                    <div className='input-one-line-dealer'>
                      <div className='input-group w-full md:w-[230px]'>
                        <label className='form-field-label'>
                          Mailing Address
                        </label>
                        <Form.Item name='field3' className='mt-1'>
                          <Field name='mailing_home_address'>
                            {({ field }) => (
                              <Input
                                {...field}
                                onBlur={(e) => handleBlur(e, formikProps)}
                              />
                            )}
                          </Field>
                          {validationDetails?.mailing_home_address
                            ?.validation == false && (
                              <span className='error'>
                                Mailing Address Required
                              </span>
                            )}
                        </Form.Item>
                      </div>
                    </div>
                    <div>
                      <label className='form-field-label'>
                        Mailing Postal Code
                      </label>
                      <Form.Item name='field3' className='mt-1'>
                        <Field name='mailing_postal_code'>
                          {({ field }) => (
                            <Input
                              maxLength={6}
                              {...field}
                              onBlur={(e) => handleBlur(e, formikProps)}
                            />
                          )}
                        </Field>
                        {validationDetails?.mailing_postal_code?.validation ==
                          false && (
                            <span className='error'>
                              Mailing Postal Code Required
                            </span>
                          )}
                      </Form.Item>
                    </div>
                  </div>
                )}
            </Form>
          )}
        </Formik>
      )}
      {guarantor_type == 'company' && (
        <Formik enableReinitialize={true} initialValues={applicantDetails}>
          {(formikProps) => (
            <Form>
              <div className='input-one-line-dealer'>
                <div className='input-group w-full md:w-[230px]'>
                  <label>Company Name</label>
                  <Form.Item name='field2' className='mt-1'>
                    <Field name='company_name'>
                      {({ field }) => (
                        <Input
                          {...field}
                          onBlur={(e) => handleBlur(e, formikProps)}
                        />
                      )}
                    </Field>
                    {validationDetails?.company_name?.validation == false && (
                      <span className='error'>Company Name Required</span>
                    )}
                  </Form.Item>
                </div>
                <div className='input-group w-full md:w-[230px]'>
                  <label>UEN/ACRA Number:</label>
                  <Form.Item name='field2' className='mt-1'>
                    <Field name='uen_acra_no'>
                      {({ field }) => (
                        <Input
                          {...field}
                          onBlur={(e) => handleBlur(e, formikProps)}
                        />
                      )}
                    </Field>
                    {validationDetails?.uen_acra_no?.validation == false && (
                      <span className='error'>UEN/ACRA Number Required</span>
                    )}
                  </Form.Item>
                </div>
                <div className='input-group w-full md:w-[230px]'>
                  <label>Date of Incorporation</label>
                  <Form.Item name='field2' className='mt-1 w-full'>
                    <Field name='date_of_incorporation'>
                      {({ field }) => (
                        <DatePicker
                          placeholder='DD-MM-YYYY'
                          className={`py-[8px] w-full md:w-[230px]`}
                          allowClear={false}
                          format='DD-MM-YYYY'
                          {...field}
                          value={
                            applicantDetails.date_of_incorporation
                              ? dayjs(applicantDetails.date_of_incorporation)
                              : null
                          }
                          name='date_of_incorporation'
                          onChange={(date) => {
                            handleDropdownChange(
                              'date_of_incorporation',
                              dayjs(date).format('YYYY-MM-DD'),
                              formikProps
                            );
                          }}
                        />
                      )}
                    </Field>
                    {validationDetails?.date_of_incorporation?.validation ==
                      false && (
                        <span className='error'>
                          Date of Incorporation Required
                        </span>
                      )}
                  </Form.Item>
                </div>
              </div>
              <div className='input-one-line-dealer'>
                <div className='input-group w-full md:w-[230px]'>
                  <label>Mobile Number</label>
                  <Form.Item name='field2' className='mt-1'>
                    <Field name='mobile_no'>
                      {({ field }) => (
                        <Input
                          maxLength={8}
                          addonBefore={'+65'}
                          {...field}
                          onBlur={(e) => handleBlur(e, formikProps)}
                        />
                      )}
                    </Field>
                    {validationDetails?.mobile_no?.validation == false && (
                      <span className='error'>Mobile Number Required</span>
                    )}
                  </Form.Item>
                </div>
                <div className='input-group w-full md:w-[230px]'>
                  <label>Office Number</label>
                  <Form.Item name='field2' className='mt-1'>
                    <Field name='office'>
                      {({ field }) => (
                        <Input
                          maxLength={8}
                          addonBefore={'+65'}
                          {...field}
                          onBlur={(e) => handleBlur(e, formikProps)}
                        />
                      )}
                    </Field>
                  </Form.Item>
                </div>
                <div className='input-group w-full md:w-[230px]'>
                  <label>Email</label>
                  <Form.Item name='field2' className='mt-1'>
                    <Field name='email'>
                      {({ field }) => (
                        <Input
                          {...field}
                          onBlur={(e) => handleBlur(e, formikProps)}
                        />
                      )}
                    </Field>
                    {validationDetails?.email?.validation == false && (
                      <span className='error'>{emailMessage}</span>
                    )}
                  </Form.Item>
                </div>
              </div>
              <div className='input-one-line-dealer'>
                <div className='input-group w-full md:w-[230px]'>
                  <label className='form-field-label'>Contact Person</label>
                  <Form.Item name='field2' className='mt-1'>
                    <Field name='name'>
                      {({ field }) => (
                        <Input
                          {...field}
                          onBlur={(e) => handleBlur(e, formikProps)}
                        />
                      )}
                    </Field>
                    {validationDetails?.name?.validation == false && (
                      <span className='error'>Contact person Required</span>
                    )}
                  </Form.Item>
                </div>
                <div className='input-group w-full md:w-[230px]'>
                  <label>Company Address</label>
                  <Form.Item name='field2' className='mt-1'>
                    <Field name='company_address'>
                      {({ field }) => (
                        <Input
                          {...field}
                          onBlur={(e) => handleBlur(e, formikProps)}
                        />
                      )}
                    </Field>
                    {validationDetails?.company_address?.validation ==
                      false && (
                        <span className='error'>Company Address Required</span>
                      )}
                  </Form.Item>
                </div>
                <div className='input-group w-full md:w-[230px]'>
                  <label>Postal Code</label>
                  <Form.Item name='field2' className='mt-1'>
                    <Field name='company_postal_code'>
                      {({ field }) => (
                        <Input
                          {...field}
                          maxLength={6}
                          onBlur={(e) => handleBlur(e, formikProps)}
                        />
                      )}
                    </Field>
                    {validationDetails?.company_postal_code?.validation ==
                      false && (
                        <span className='error'>Postal Code Required</span>
                      )}
                  </Form.Item>
                </div>
              </div>
              <div className='input-one-line-dealer'>
                <div className='input-group w-full md:w-[230px]'>
                  <label>Company address same as mailing address?</label>
                  <Form.Item name='field3' className='mt-1'>
                    <Field name='company_address_same_as_mailing'>
                      {({ field }) => (
                        <Radio.Group
                          {...field}
                          onChange={(e) => handleChange(e, formikProps)}
                        >
                          <Radio key={1} value={1}>
                            <label className='form-field-label'>Yes</label>
                          </Radio>
                          <Radio key={0} value={0}>
                            <label className='form-field-label'>No</label>
                          </Radio>
                        </Radio.Group>
                      )}
                    </Field>
                    {validationDetails?.company_address_same_as_mailing
                      ?.validation == false &&
                      applicantDetails.company_address_same_as_mailing ==
                      '' && <span className='error'> Required</span>}
                  </Form.Item>
                </div>
              </div>
              {formikProps.values.company_address_same_as_mailing == 0 &&
                validationDetails?.company_address_same_as_mailing
                  ?.validation == true && (
                  <div className='input-one-line-dealer'>
                    <div className='input-group w-full md:w-[230px]'>
                      <label className='!mb-6'>Mailing Company Address</label>
                      <Form.Item name='field2'>
                        <Field name='mailing_company_address'>
                          {({ field }) => (
                            <Input
                              {...field}
                              onBlur={(e) => handleBlur(e, formikProps)}
                            />
                          )}
                        </Field>
                        {validationDetails?.mailing_company_address
                          ?.validation == false && (
                            <span className='error'>
                              {' '}
                              Mailing Address Required
                            </span>
                          )}
                      </Form.Item>
                    </div>
                    <div className='input-group w-full md:w-[230px]'>
                      <label className='!mb-6'>Mailing Postal Code</label>
                      <Form.Item name='field2'>
                        <Field name='mailing_company_postal_code'>
                          {({ field }) => (
                            <Input
                              {...field}
                              maxLength={6}
                              onBlur={(e) => handleBlur(e, formikProps)}
                            />
                          )}
                        </Field>
                        {validationDetails?.mailing_company_postal_code
                          ?.validation == false && (
                            <span className='error'> Postal Code Required</span>
                          )}
                      </Form.Item>
                    </div>
                  </div>
                )}
            </Form>
          )}
        </Formik>
      )}
    </div>
  );
};

export default GuarantorPersonalDetails;
